import React from 'react'
import Fragment from '../common/fragment'


function FragmentCM(props) {
  return (
    <Fragment pos="mmm" {...props}>
      <p>
“Los seres humanos quemadores de fósiles parecen decididos a hacer todos los
fósiles que sea posible, tan rápidamente como sea posible.” (Haraway, 81)
      </p>
    </Fragment>
  )
}


export default FragmentCM
